import { useNavigate } from 'react-router-dom';
import Toggle from '../Toggle/Toggle';
import { useFeatureFlags, useSetFlag } from '../../contexts/FeatureFlagsContext';
import { usePermissions } from '../../contexts/AuthContext';
import styles from './DevFlagToggle.module.scss';

function DevFlagToggleInner() {
  const { useRevamp } = useFeatureFlags();
  const setFlag = useSetFlag();
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <Toggle
        id="dev-flag-revamp"
        checked={useRevamp}
        onChange={(val) => {
          setFlag('useRevamp', val);
          navigate(val ? '/organization' : '/');
        }}
        label="Revamp"
      />
    </div>
  );
}

export function DevFlagToggle() {
  const { hasPermission } = usePermissions();
  if (!hasPermission('CapacityManagement.RevampUI.Read')) return null;
  return <DevFlagToggleInner />;
}
